import { render } from "./user-ongoing-modal.vue?vue&type=template&id=41782798"
import script from "./user-ongoing-modal.vue?vue&type=script&lang=js"
export * from "./user-ongoing-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__